// Application-wide tunable constants.
// Centralising these makes intent explicit and avoids "magic numbers" in components.

// React Query: how long data is considered fresh before re-fetching.
export const QUERY_STALE_TIME_MS = 60_000; // 60 seconds

// Navbar: vertical scroll (in px) after which the header switches to its
// scrolled (ivory background) state.
export const NAVBAR_SCROLL_THRESHOLD_PX = 30;

// Navbar: mobile hamburger / close icon size (in px).
export const MOBILE_TOGGLE_ICON_SIZE_PX = 22;
